import { Component, inject, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ViewTransactionService } from '../../../modules/services/view-transaction.service';
import { SocketService } from '../../../modules/services/socket.service';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
  viewTransactionService = inject(ViewTransactionService);
  socketService = inject(SocketService);
  pendingCount: any;

  ngOnInit(): void {
    this.getPendingCount();
    this.listenApprovedEvent();
    this.listenProposalEvent();
  }
  
  /**
   * Gets pending count
   */
  getPendingCount() {
    this.viewTransactionService.getPendingTransactionCount().subscribe({
      next: (response: any) => {
        console.log('count res', response);
        this.pendingCount = response.data.pendingCount;
      },
      error: (error: any) => {
        console.log('pending err', error);
      }
    })
  }

  /**
   * Listens approved event
   */
  listenApprovedEvent() {
    this.socketService.on('transaction_approved').subscribe((data: any) => {
      console.log('socket proposal data', data);
      this.getPendingCount();
    })
  }

  /**
   * Listens proposal event
   */
  listenProposalEvent() {
    this.socketService.on('transaction_proposed').subscribe((data: any) => {
      console.log('socket proposal data', data);
      this.getPendingCount();
    })
  }
}
